import type { FeatureConfig } from '@skynet/feature-config';
import { FundOutlined } from '@ant-design/icons';

import { ARBITRATION_ROUTE_PATH, ARBITRATION_URL } from './routes';

/**
 * Feature manifest for the admin Arbitration page. The dashboard shell reads
 * this single source of truth instead of hardcoding the route, navigation
 * entry, header label and Cerbos action across its routing, navigation, header
 * and access-control modules.
 *
 * `route.load` is a dynamic-import thunk, so importing this config for its
 * nav/header metadata never pulls the page implementation into the main bundle.
 * The config imports nothing from `@skynet/sky-arbitrage`, so reading it never
 * drags the Arbitrage UI onto the boot path.
 *
 * `section`, `nav.key` and `cerbosAction` stay literal: they are the identifier
 * the Cerbos policy is written against (`read:admin:arbitrage`), and renaming
 * any of them hides the nav item until the policy is renamed too.
 */
export const arbitrageConfig = {
  domain: 'Admin',
  section: 'arbitrage',
  route: {
    path: ARBITRATION_ROUTE_PATH,
    load: async () => ({ default: (await import('./ArbitrationPage')).ArbitrationPage }),
  },
  nav: {
    key: 'admin.arbitrage',
    label: 'Arbitrage',
    icon: <FundOutlined />,
    url: ARBITRATION_URL,
  },
  header: { label: 'ARBITRAGE' },
  cerbosAction: 'read:admin:arbitrage',
  needsEntityId: false,
} as const satisfies FeatureConfig;
